import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ErrorHandlerModule } from "./errors/error-handler.module";
import { FooterComponent } from "./footer/footer.component";
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from "../shared/material.module";
import { ControlsSampleComponent } from './controls-sample/controls-sample.component';
import { FlexLayoutModule } from "@angular/flex-layout";
import { ThemeService } from "./services/theme.service";
import { StyleManagerService } from "./services/style-manager.service";
import { ThemeMenuComponent } from "./controls-sample/theme-menu/theme-menu.component";
import { WelcomeComponent } from './welcome/welcome.component';
import { MatLabelTooltipComponent } from './controls/mat-label-tooltip/mat-label-tooltip.component';
import {SwiperModule} from "swiper/angular";
import {MatCarouselModule} from "ng-mat-carousel";
import { SecurityDialogComponent } from './header/dialogs/security-dialog/security-dialog.component';
import {InformationSecurityComponent} from "./information-security/information-security.component";
import { DebugInfoComponent } from "./header/debug-info/debug-info.component";
import { FdicImgComponent } from './header/fdic-img/fdic-img.component';
import {AbandonedComponent} from "./abandoned-card/abandoned-component";
import {BrandService} from "./services/brand.service";
import { SelectComponent } from './controls/toolkit/select/select.component';
import { ReactiveFormsModule } from "@angular/forms";
import { IconButtonComponent } from './controls/toolkit/icon-button/icon-button.component';
import { DeleteIconButtonComponent } from './controls/toolkit/delete-icon-button/delete-icon-button.component';

@NgModule({
  exports: [
    FooterComponent,
    HeaderComponent,
    FdicImgComponent,
    ControlsSampleComponent,
    WelcomeComponent,
    MatLabelTooltipComponent,
    InformationSecurityComponent,
    AbandonedComponent,
    SelectComponent,
    IconButtonComponent,
    DeleteIconButtonComponent
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    FdicImgComponent,
    ControlsSampleComponent,
    ThemeMenuComponent,
    WelcomeComponent,
    MatLabelTooltipComponent,
    SecurityDialogComponent,
    InformationSecurityComponent,
    DebugInfoComponent,
    AbandonedComponent,
    SelectComponent,
    IconButtonComponent,
    DeleteIconButtonComponent
  ],
  imports: [CommonModule, ErrorHandlerModule, MaterialModule, FlexLayoutModule, SwiperModule, MatCarouselModule.forRoot(), ReactiveFormsModule],
  providers: [StyleManagerService, ThemeService, BrandService]
})

export class CoreModule {
}
